// 说明：手机端路由配置
// 注意：路由配置中的component属性，对应的是src/views/phone目录下的组件
const routers = [
    {   path: '/',
        redirect: '/phonePage',
        name: 'HelloWorld',
        component: () => import('@/views/HelloWorld.vue')
    },
    {
        path: '/phonePage',
        // redirect: '/home',
        name: 'phonePage',
        component: () => import('@/views/phone/phonePage.vue')
        // component: () => import('@/views/pcpage/phonePage.vue')
    },
    {
        path: '/art',
        name: 'art',
        component: () => import('@/views/phone/artPage.vue')
    },
    {
        path: '/ill',
        name: 'ill',
        component: () => import('@/views/phone/illPage.vue')
    },
    {
        path: '/yiMei',
        name: 'yiMei',
        component: () => import('@/views/phone/yiMei.vue')
    },
    {
        path: '/voice',
        name: 'voice',
        component: () => import('@/views/phone/voice.vue')
    },
    {
        path: '/live',
        name: 'live',
        component: () => import('@/views/phone/livePage.vue')
    },
    {
      path: '/EnterpriseRegistration',
      name: 'EnterpriseRegistration',
      component: () => import('@/views/phone/EnterpriseRegistration.vue')
    },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/phone/aboutUs.vue')
    },
    {
        path: '/VotingList',
        name: 'VotingList',
        component: () => import('@/views/phone/VotingList.vue')
    },
    {
        path: '/privacypolicy',
        name: 'Privacypolicy',
        component: () => import('@/views/privacypolicy.vue')
    }

]
// const routers = [
//     {   path: '/',
//         name: 'HelloWorld',
//         component: () => import('@/views/HelloWorld.vue')
//     }
// ]
export default routers;



// WEBPACK FOOTER //
// ./src/router/phoneRouter.js